export default __webpack_public_path__ + "static/media/exposed.77b49c65.svg";